document.addEventListener("DOMContentLoaded", function() {
  const toggleFilterBtn = document.getElementById("toggleFilterBtn");
  const filterLayout = document.getElementById("filterLayout");
  const filterIconOpen = document.getElementById("filterIconOpen");
  const filterIconClose = document.getElementById("filterIconClose");
  
  toggleFilterBtn.addEventListener("click", function() {
    filterLayout.classList.toggle("show");
    toggleFilterBtn.classList.toggle("button-right");
    filterIconOpen.classList.toggle("hidden")
    filterIconClose.classList.toggle("hidden")
  });
  
  const announcementBar = document.querySelector("#shopify-section-announcement-bar");
  const mainMenu = document.querySelector("#shopify-section-header");
  const navbar = document.querySelector(".nav-bar");
  
  // Update padding of filter bar on scroll using the header size as a reference
  window.addEventListener('scroll', function(){
    const headerHeight = announcementBar.offsetHeight + mainMenu.offsetHeight + navbar.offsetHeight;
    const extraPadding = 16;
    filterLayout.style.paddingTop = navbar.offsetHeight + extraPadding + "px";
    if(window.pageYOffset < navbar.offsetHeight) {
      filterLayout.style.paddingTop = headerHeight + extraPadding + "px";
    } else {
      filterLayout.style.paddingTop = navbar.offsetHeight + extraPadding + "px";
    }
  });
});
